import React, { Suspense, useState } from 'react';
import { useCookies } from 'react-cookie'
import {
  BrowserRouter as Router,
  Route
} from "react-router-dom";
import './App.css';

const App = () => {
  const [cookies, setCookie] = useCookies(['idUsuario', 'UrlAPI']);
  setCookie("UrlAPI", "https://app.programapia2.com.ar/api/index.php/");
  // setCookie("UrlAPI", "http://localhost:8081/index.php/");
  // setCookie("UrlAPI", "http://pia.local:8085/index.php/");
  // setCookie("UrlAPI", "http://192.168.0.8:8085/index.php/");

  const Home = React.lazy(() => import('./home/Home'));
  const Chat = React.lazy(() => import('./chat/Chat'));
  const Participante = React.lazy(() => import('./participante/Participante'));
  const Administracion = React.lazy(() => import('./administracion/Administracion'));
  const MediaQuiz = React.lazy(() => import('./media-quiz/MediaQuiz'));
  const ListadoInstituciones = React.lazy(() => import('./administracion/ListadoInstituciones'));
  const Institucion = React.lazy(() => import('./administracion/Institucion'));
  const NuevaInstitucion = React.lazy(() => import('./administracion/NuevaInstitucion'));
  const Curso = React.lazy(() => import('./administracion/Curso'));
  const NuevoCurso = React.lazy(() => import('./administracion/NuevoCurso'));
  const ModificarUsuario = React.lazy(() => import("./administracion/ModificarUsuario"))

  return (
  
    <Router>
      <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
      <div className="App">
        <div className="App-wrapper">
          <div className="App-principal">
            <div className="App-header">
            <img src="https://app.programapia2.com.ar/Logo-pia.png" style={{width:"35px", marginRight:"15px"}}></img>
              <h1>Programa PIA-2</h1>
            </div>
            <div className="App-content">
              <Suspense fallback={<div>Cargando...</div>}>
                <Route exact path="/" component={Home} />
                <Route exact path="/chat" component={Chat} />
                <Route exact path="/media-quiz" component={MediaQuiz} />
                
                <Route exact path="/participante" component={Participante} />
                <Route exact path="/administracion" component={Administracion} />
                <Route exact path="/administracion/instituciones" component={ListadoInstituciones} />
                <Route exact path="/administracion/instituciones/ver/:idInstitucion" component={Institucion} render={(props) => <Institucion idInstitucion={props} />} />
                <Route exact path="/administracion/instituciones/nueva" component={NuevaInstitucion} />
                <Route exact path="/administracion/cursos/ver/:idCurso" component={Curso} render={(props) => <Curso idCurso={props} />} />
                <Route exact path="/administracion/cursos/nuevo/:idInstitucion" component={NuevoCurso} render={(props) => <NuevoCurso idInstitucion={props} />} />
                <Route exact path="/administracion/usuarios/modificar/:idUsuario" component={ModificarUsuario} render={(props) => <ModificarUsuario idUsuario={props} />} />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
